import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { IBrandCostRequest } from "@shared/lib/types/briefInfluencerV2";
import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export function useEditBrandCost(briefId: string) {
  const {
    mutate: editCost,
    isLoading: isEditing,
    isSuccess: isEdited,
  } = useMutation({
    mutationFn: (data: IBrandCostRequest) =>
      BriefService.editBrandCost(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
      });
    },
  });

  return {
    editCost,
    isEditing,
    isEdited,
  };
}
